module.exports = __webpack_public_path__ + "static/media/YF84_10.1fffccc4.jpg";